import { simpleFetchWithHttp } from './customFetch';
import { getCouponCode } from '../helpers';

export const updateSubscription = (plan, currentPlan, couponsApplied = []) => {
  const couponCode = getCouponCode(couponsApplied);
  return simpleFetchWithHttp(
    '/api/1/upgrade',
    {
      method: 'POST',
      body: JSON.stringify({
        target_plan_code: plan,
        current_plan_code: currentPlan,
        coupon_code: couponCode,
      }),
    },
    process.env.REACT_APP_REGISTRATION_API,
  );
};

export const reactivateExpiredSubscription = (plan, couponsApplied = []) => {
  const couponCode = getCouponCode(couponsApplied);
  return simpleFetchWithHttp(
    '/api/1/reactivate/expired',
    {
      method: 'POST',
      body: JSON.stringify({
        plan_code: plan,
        coupon_code: couponCode,
      }),
    },
    process.env.REACT_APP_REGISTRATION_API,
  );
};

export const reactivateCancelledSubscription = (couponsApplied = []) => {
  const couponCode = getCouponCode(couponsApplied);

  return simpleFetchWithHttp(
    '/api/1/reactivate/cancelled',
    {
      method: 'POST',
      body: JSON.stringify({
        coupon_code: couponCode,
      }),
    },
    process.env.REACT_APP_REGISTRATION_API,
  );
};
